import React from 'react';
export function FinalTruthSection() {
  return <section className="w-full bg-white py-8 md:py-12 lg:py-16 px-4 md:px-6 border-t-[3px]" style={{
    borderColor: '#2D9B6E',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  }} data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <h2 className="text-[29px] md:text-[34px] lg:text-[43px] font-bold mb-10 text-center" style={{
        color: '#1B4F9E'
      }} data-id="element-3">
          THE FINAL TRUTH
        </h2>

        {/* Family Image */}
        <div className="mb-10 -mx-4 md:-mx-6" data-id="element-4">
          <img src="https://cdn.magicpatterns.com/uploads/c4d2zgEodPteNixBbtmjfc/unnamed_(11).jpg" alt="Test Your Protection Today - See the EMF reduction on your meter in 48 hours. Join 1,000+ Australian families protecting their homes." className="w-full rounded-lg shadow-md" data-id="element-5" />
        </div>

        {/* Body Copy */}
        <div className="text-base md:text-lg leading-relaxed space-y-5 text-center max-w-[800px] mx-auto" style={{
        color: '#2C3E50',
        lineHeight: '1.7'
      }} data-id="element-6">
          <p data-id="element-7">
            You've read this far because something in your life isn't right.
            Whether it's your sleep, your teenager's phone addiction, your brain
            fog, or just the sense that constant WiFi exposure isn't natural—you
            know something needs to change.
          </p>

          <p data-id="element-8">
            The 15,000+ Australian families who ordered QShield didn't have it
            all figured out. They just took one simple step: measure their EMF
            exposure, reduce it with stickers, and see what improved.
          </p>

          <p data-id="element-9">
            <strong data-id="element-10">Smart meter rollout begins December 2025.</strong> 5G
            continues expanding.{' '}
            <strong data-id="element-11">Your exposure will only increase.</strong> The earlier you
            take protective steps, the longer the benefit. Families who started
            in 2024 have already had a year of improved sleep. Your year could
            start this week.
          </p>
        </div>

        {/* Emphasis Block */}
        <div className="mt-8 p-6 md:p-7 rounded border-l-4 max-w-[800px] mx-auto" style={{
        backgroundColor: '#F0F7FF',
        borderColor: '#1B4F9E'
      }} data-id="element-12">
          <p className="text-base md:text-[17px] font-medium italic text-center" style={{
          color: '#1B4F9E',
          lineHeight: '1.8'
        }} data-id="element-13">
            Whether or not you feel dramatic health changes, you'll have done
            something concrete to protect your family. And that peace of
            mind—knowing you've taken a measurable step—is where most customers
            say the real benefit was.
          </p>
        </div>
      </div>
    </section>;
}